export const TableModul = [
  {
    id: "1",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "paid",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
  {
    id: "2",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "expired",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
  {
    id: "3",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "requested",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
  {
    id: "4",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "requested",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
  {
    id: "5",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "expired",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
  {
    id: "6",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "paid",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
  {
    id: "7",
    amount: 25.01,
    token: "USDT",
    tokenIcon: "/images/tokens/tether.svg",
    network: "Avalanche",
    networkIcon: "/images/networks/avalanche.svg",
    creationDate: "11.08.2022",
    paymentDate: "11.08.2022",
    time: "08:00 PM",

    status: "paid",
    nftLink: "google.com",
    txLink: "0x0222d0...cf5796",
    invoiceLink: "0x0222d0...cf5796",
    senderAdress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    recievedAddress: "0x7295d96ED2C37173F0C3B4dB28447FE38202F27",
    senderName: "Bored Ape",
  },
];
